import React, { Component } from 'react';

class PanelNovedad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editandoOtroComponente: false
        };
        this.modificarCampo = this.modificarCampo.bind(this);
        this.aceptarCambios = this.aceptarCambios.bind(this);
        this.abrirHistorial = this.abrirHistorial.bind(this);
    }

    componentWillUnmount() {
        if (this.props.data.editandoCampo && this.props.data.editandoCampo == this.props.codigoCampo) {
            this.props.funcionLimpiarStore(this.props.nombreCampo, this.props.seccion);
        }
    }

    modificarCampo(accion) {
        if (accion == true) {
            if (this.props.data.editandoCampo) {
                this.setState({ editandoOtroComponente: true })
            } else {
                this.setState({ modoEdicion: accion, editandoOtroComponente: false })
                if (!this.props.novedad.length > 0) {
                    this.props.funcionEdicion(this.props.nombreCampo, this.props.valorActual, null, this.props.seccion);
                } else {
                    let valorNovedadActual = this.props.novedad[0].ValorNovedad;
                    this.props.funcionEdicion(this.props.nombreCampo, this.props.valorActual, valorNovedadActual, this.props.seccion);
                }
            }
        } else {
            this.setState({ modoEdicion: accion, editandoOtroComponente: false })
            if (!this.props.novedad.length > 0) {
                this.props.funcionEdicion(this.props.nombreCampo, this.props.valorActual, null, this.props.seccion);
            } else {
                let valorNovedadActual = this.props.novedad[0].ValorNovedad;
                this.props.funcionEdicion(this.props.nombreCampo, this.props.valorActual, valorNovedadActual, this.props.seccion);
            }
            this.props.funcionEdicion(this.props.nombreCampo, null, null, this.props.seccion, true);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.editandoOtroComponente && this.props.data.editandoCampo != nextProps.data.editandoCampo && nextProps.data.editandoCampo != this.props.data.codigoCampo) {
            this.setState({ editandoOtroComponente: false })
        }
    }

    aceptarCambios() {
        let valorActual = this.props.valorActual;
        let valorNovedad = this.props.data[this.props.codigoCampo];
        if (!this.props.novedad[0] && valorActual == valorNovedad) {
            this.modificarCampo(false);
        } else {
            this.props.guardarNovedad(valorActual, this.props.seccion, this.props.tarjetaId)
            if (!this.props.funcionValidar || !this.props.funcionValidar(this.props.nombreCampo)) {
                this.modificarCampo(false);
            }
        }
    }

    abrirHistorial(accion) {
        if (accion == true) {
            let novedadCodigo = this.props.codigoCampo;
            let cuentaId = this.props.data.CuentaTarjetaId;
            this.props.logHistorialCambios(novedadCodigo, cuentaId, this.props.seccion)
        } else {
            this.props.logHistorialCambios(false, null, this.props.seccion)
        }
    }

    /*
        ..............................................PROPS.....................................................
    
        aceptarCambios //función de guardado de la novedad 
        nombreCampo //código de la novedad
        data //store del componente
        tituloCampo //título a mosotrar
        valorActualDescripcion //descripción del valor actual 
        valorActual // valor actual real (Id en caso de que la modificación sea con combo)
        novedad //arreglo con un solo índice que contiene la última novedad correspondiente al campo 
        cambiarEstadoNovedad //función que cambia el estado de una novedad
        opciones //opciones posibles para elegir en el combo de modificación de un campo
        codigoCampo //código de la novedad
        selectCombo //función que selecciona el nuevo valor para el campo
        funcionEdicion //función que selecciona el campo en edición
        guardarNovedad //función para guardar novedad
        muestraBotonHistorial //booleano para determinar si se muestra o no el botón del historial de novedades
        logHistorialCambios //función para cargar los datos del historial y abrirlo
        componenteModificaciones // componente historial de modificaciones
        logModificacionesAbierto= //booleano para determinar si se debe mostrar o no el modal del historial
        seccion= //sección actual en la que se encuentra el panel, para que se puedan reutilizar las actions
        tarjetaId // sólo para campos de tarjeta de crédito, para que se asigne los cambios al integrante correspondiente
        funcionLimpiarStore // función para que corra al desmontar el componente y limpie el store de campos que afectan a la edición y validaciones
        maxLengthInput // largo máximo para el input de modificación
        patternInput // regex para caracteres permitidos
        errorValidacion // mensaje de error por validación
        funcionValidar // función que determina si se cierra el modo edición porque se pasaron las validaciones o no
        mostrarSpinner // propiedad que indica si se debe mostrar únicamente el spinner porque se está trabajando con datos del campo
        .........................................................................................................
        */
    render() {
        let { novedad
            , opciones
        } = this.props;

        if (novedad.length < 1) novedad = false;
        let valorCampo = this.props.valorActualDescripcion || "";
        let novedadCampo = ""; //string para la leyendda al pie del campo que indica los detalles de la novedad
        let novedadDescripcion; //string para mostrar el valor de la novedad, obtenido a partir del arreglo de opciones y el id de valorNovedad
        let valorActualDescripcion; // valorActual refiere en realidad al valor que tenía el campo antes de la modificación / novedad, será actual hasta que la administradora apruebe la novedad
        let claseConfirmado = this.state.openConfirmador && this.state.confirma ? "botonConfirmadoModificacionCampo" : "";
        let claseDenegado = this.state.openConfirmador && !this.state.confirma ? "botonDenegadoModificacionCampo" : "";
        let habilitaModificacion = true;
        
        if(this.props.mostrarSpinner || this.props.novedad[0] && this.props.novedad[0].NovedadEstadoId ==2) return <div className="loading"></div>

        if (novedad) {

            if (novedad.NovedadEstadoId != 1 && novedad.NovedadEstadoId != 2 && novedad.NovedadEstadoId != 3) habilitaModificacion = false;
        }

        if (novedad) {
            let novedad = this.props.novedad[0];
            novedadDescripcion = novedad.ValorNovedad;
            valorActualDescripcion = novedad.ValorAnterior;
            
            let descripcionEstado = this.props.parametroGeneral && !this.props.parametroGeneral.SINOCONFIRMACIONMODIFCTA && this.props.nombreCampo == "SUCUR_CUEN" ? "Editado: " : "Confirmado: ";
            let fechaMod = JSON.parse(JSON.stringify(novedad.FechaHoraModificacion));
            let fechaConf = JSON.parse(JSON.stringify(novedad.FechaHoraConfirmacion));

            if (fechaMod) {
                fechaMod = fechaMod.replace("T", " ");
                fechaMod = fechaMod.split(".")[0]
            }

            if (fechaConf) {
                fechaConf = fechaConf.replace("T", " ");
                fechaConf = fechaMod.split(".")[0]
            }

            Array.isArray(opciones) && opciones.map(opcion => {
                if (opcion.Id == novedad.ValorAnterior) {
                    valorActualDescripcion = opcion.Descripcion;

                }
                if (opcion.Id == novedad.ValorNovedad) {
                    novedadDescripcion = opcion.Descripcion;

                }
            });

            switch (novedad.NovedadEstadoId) {
                case 1: {
                    novedadCampo = "Editado: " + fechaMod + " por " + novedad.UsuarioLoginModificacion + ". Actual: " + valorActualDescripcion + ". Estado: " + novedad.NovedadEstadoDescripcion;
                    break;
                }
                case 2: {
                    novedadCampo = "Confirmado: " + fechaConf + " por " + novedad.UsuarioLoginModificacion + ". Actual: " + valorActualDescripcion + ". Estado: " + novedad.NovedadEstadoDescripcion;
                    claseConfirmado = "botonConfirmadoModificacionCampo";
                    break;
                }
                case 22://estado asignado por la action que trae las novedades luego de denegar para que se muestre denegada por una única vez hasta salir de la pantalla
                case 3: {
                   // novedadCampo = "Denegado: " + fechaMod + " por " + novedad.UsuarioLoginModificacion + ". Actual: " + valorActualDescripcion + ". Estado: " + novedad.NovedadEstadoDescripcion;
                    claseDenegado = "botonDenegadoModificacionCampo";
                    break;
                }
                case 4: {
                    novedadCampo = descripcionEstado + fechaMod + " por " + novedad.UsuarioLoginModificacion + ". Actual: " + valorActualDescripcion + ". Estado: " + novedad.NovedadEstadoDescripcion;
                    claseConfirmado = "botonConfirmadoModificacionCampo";
                    break;
                }
                case 21: {//estado asignado por la action que trae las novedades luego de que resulte rechazada la novedad para que se muestre rechazada por una única vez hasta salir de la pantalla
                    novedadCampo = "Editado: " + fechaMod + " por " + novedad.UsuarioLoginModificacion + ". Actual: " + valorActualDescripcion + ". Estado: " + novedad.NovedadEstadoDescripcion;
                    claseConfirmado = "botonConfirmadoModificacionCampo";
                    break;
                }
            }
        }

        if (!this.state.modoEdicion && !novedad) {

            return (
                <div className=" no-padding">
                    <label className="label-primary">{this.props.tituloCampo}</label>
                    {<div className=" bottom-separator-xs">
                        <div className="camposEdicionCuenta edit-panel-lapiz-new">
                            {this.props.permisoModificacion ?
                                <div className={" clickable camposEdicionCuenta edit-panel-lapiz-child color-azul-claro " + (this.props.claseLabel ? this.props.claseLabel : "")} onClick={() => this.modificarCampo(true)}>{valorCampo ? valorCampo : " - "}</div> :                                
                                <div className={" camposEdicionCuenta " + (this.props.claseLabel ? this.props.claseLabel : "")}>{valorCampo ? valorCampo : " - "}</div>}
                            {this.props.muestraBotonHistorial && <div onClick={() => this.abrirHistorial(true)} className="edit-panel-icono-historial icon-icono-modificaciones"></div>}
                        </div>
                        {this.state.editandoOtroComponente && this.props.data.editandoCampo && this.props.data.editandoCampo != this.props.data.codigoCampo && <label className="errorEditandoNovedad">Se está modificando otro campo</label>}
                    </div>}
                    {this.props.logModificacionesAbierto && this.props.componenteModificaciones}
                </div>
            );
        } else if (!this.state.modoEdicion && novedad) {
            if (Array.isArray(novedad)) {
                novedad = novedad[0]
                novedad.Codigo = novedad.NovedadCampoCodigo
            }
            let desc = novedad.NovedadEstadoId == 21 || novedad.NovedadEstadoId == 22 || novedad.NovedadEstadoId == 6 
                       || novedad.NovedadEstadoId == 3 ? valorActualDescripcion : novedadDescripcion;

            return (
                <div className=" no-padding bottom-separator-xs">
                    <label className="label-primary">{this.props.tituloCampo}</label>
                    {this.props.nombreCampo == "GRUPA_CUEN" || this.props.nombreCampo == "SUCUR_CUEN" ?
                        <div className="list-group-item-heading">
                            <div className="fakeSelectCampoNovedad" onClick={() => this.props.permisoModificacion ? this.modificarCampo(true) : null}>
                                {desc}
                            </div>
                            {/* En caso que la novedad este denegada, rechazada o enviada no tiene que mostrar el boton de confiramción (3-denegada 4-Enviada 6-Rechazada) */}
                            {novedad.NovedadEstadoId != 4 && novedad.NovedadEstadoId != 21 && novedad.NovedadEstadoId != 22 && novedad.NovedadEstadoId != 6 && novedad.NovedadEstadoId != 3 && this.props.permisoConfirmacion && 
                            <div className={"icon-confirmado iconosNovedades botonConfirmarModificacionCampo " + claseConfirmado} onClick={() => this.props.cambiarEstadoNovedad(novedad.Id, 2, novedad.Codigo, this.props.data.entidadTipo, this.props.data.entidadTipo, this.props.seccion)}></div>}
                            <div className="contenedor-Denegar">
                                {novedad.NovedadEstadoId != 4 && novedad.NovedadEstadoId != 21 && novedad.NovedadEstadoId != 3 && novedad.NovedadEstadoId != 6 && novedad.NovedadEstadoId != 22 && 
                                    <div onClick={() => { this.props.openModal(2, undefined, undefined, true);
                                        this.props.guardarNovedadParaDenegar(novedad.Id, 3, novedad.Codigo, this.props.data.entidadTipo,
                                        this.props.seccion, this.props.nombreCampo) }  } 
                                        className={"icon-denegado iconosNovedades botonDenegarModificacionCampo " + claseDenegado}> 
                                    </div>}
                                {this.props.modalDenegacionDeCuenta && this.props.nombreCampoModal == this.props.nombreCampo &&
                                    this.props.ModalDatosCuentaConPunta
                                    }       
                                </div>
                            <div onClick={() => this.abrirHistorial(true)} className="icon-icono-modificaciones iconosNovedades btnHistoriaNovedadesPos"></div>
                        </div>
                        :
                        <div className="list-group-item-heading">
                            <div className="fakeSelectCampoNovedad" onClick={() => this.props.permisoModificacion ? this.modificarCampo(true) : null}>
                                {desc}
                            </div>
                            {novedad.NovedadEstadoId != 21 && this.props.permisoConfirmacion && <div className={"icon-confirmado iconosNovedades botonConfirmarModificacionCampo " + claseConfirmado} onClick={() => this.props.cambiarEstadoNovedad(novedad.Id, 2, novedad.Codigo, this.props.data.entidadTipo, this.props.data.entidadTipo, this.props.seccion)}></div>}
                            {novedad.NovedadEstadoId != 21 && <div onClick={() => this.props.cambiarEstadoNovedad(novedad.Id, 3, novedad.Codigo, this.props.data.entidadTipo, this.props.data.entidadTipo, this.props.seccion)} className={"icon-denegado iconosNovedades botonDenegarModificacionCampo " + claseDenegado}></div>}
                            <div onClick={() => this.abrirHistorial(true)} className="icon-icono-modificaciones iconosNovedades btnHistoriaNovedadesPos"></div>
                        </div>
                    }
                    <div className=" novedadResumenCampo">{novedadCampo}</div>
                    {this.state.editandoOtroComponente && this.props.data.editandoCampo && this.props.data.editandoCampo != this.props.data.codigoCampo && <label className="errorEditandoNovedad">Se está modificando otro campo</label>}
                    {this.props.logModificacionesAbierto && this.props.componenteModificaciones}
                </div>
            );
        } else if (this.state.modoEdicion && this.props.permisoModificacion) {

            let Editor = !this.props.esInput ? combo(this.props.opciones, this.props.codigoCampo, this.props.selectCombo, this.props.classSelected, this.props.data, this.modificarCampo, this.aceptarCambios, this.props.seccion)
                : input(this.props.selectCombo, this.props.nombreCampo, this.props.seccion, this.props.data[this.props.nombreCampo], this.aceptarCambios, this.modificarCampo, this.props.maxLengthInput ? this.props.maxLengthInput : null, this.props.patternInput ? this.props.patternInput : null);
            return (
                <div className=" bottom-separator-xs no-padding">
                    <label className="label-primary">{this.props.tituloCampo}</label>
                    <div className="form-group list-group-item-heading">
                        {Editor}
                    </div>
                    <div className="novedadResumenCampo">{novedadCampo}</div> 
                    {this.props.errorValidacion && <label className="error">{this.props.errorValidacion}</label>}
                </div>
            );
        }
    }
}

export default PanelNovedad;

const combo = (infoData, codigoCampo, selectCombo, classSelected, selecciones, cerrarEditor, funcionAceptar, seccion) => {

    let black = false
    let firstOption = { Id: 0, Descripcion: "Seleccione..." }

    let opcionSeleccionadaEncontrada = infoData.filter((e) => e.Id == selecciones[codigoCampo])[0]
    if (opcionSeleccionadaEncontrada) {
        firstOption = { Id: opcionSeleccionadaEncontrada.Id, Descripcion: opcionSeleccionadaEncontrada.Descripcion }
    }

    if (selecciones[codigoCampo] == firstOption.Id) black = true

    return (
        <div>
            <select className={"inputBox " + classSelected} style={black ? { color: "black" } : null} value={selecciones[codigoCampo]} onChange={(event) => {
                const index = event.target.selectedIndex;
                const value = event.target.options[index].value;
                selectCombo(codigoCampo, value, seccion);
            }}>
                <option key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option>
                {infoData.length > 0 && infoData.map((item, index) => { return <option style={{ color: "black" }} key={index} value={item.Id}>{item.Descripcion}</option> })}
            </select>
            <button className="btn btn-primary btn-cta botonesModificacionCampo" onClick={() => funcionAceptar()} >Listo</button>
            <button className="btn btn-secondary btn-cta botonesModificacionCampo" onClick={() => cerrarEditor(false)}>Cancelar</button>
        </div>
    );
}

const input = (funcionEdicion, nombreCampo, seccion, valor, funcionAceptar, cerrarEditor, maxLengthInput, patternInput) => {
    return (<div>
        <input
            maxLength={maxLengthInput}
            className='inputEdicionNovedad'
            onChange={(e) => {
                if (patternInput) {
                    if (patternInput.test(e.target.value)) {

                        return funcionEdicion(nombreCampo, e.target.value, seccion)
                    }
                } else {
                    return funcionEdicion(nombreCampo, e.target.value, seccion)
                }
            }}
            value={valor ? valor : ""}
        ></input>
        <button className="btn btn-primary btn-cta botonesModificacionCampo" onClick={() => funcionAceptar()} >Listo</button>
        <button className="btn btn-secondary btn-cta botonesModificacionCampo" onClick={() => cerrarEditor(false)}>Cancelar</button>
    </div>)
}